import { HttpErrorResponse, HttpInterceptorFn, HttpStatusCode } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { toast } from 'ngx-sonner';
import { catchError, throwError } from 'rxjs';
import { v7 as uuidv7 } from 'uuid';

import { ToastrErrorComponent } from '../shared/components/toastr/toastr-error.component';

export const erreurInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const toastrId = uuidv7();

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      switch (error.status) {
        case HttpStatusCode.BadRequest:
          toast.custom(ToastrErrorComponent, {
            componentProps: {
              message: error.error.detail,
              id: toastrId,
            },
            id: toastrId,
          });
          break;
        case HttpStatusCode.NotFound:
          router.navigate(['/non-trouvé']);
          break;
      }
      return throwError(() => error);
    }),
  );
};
